'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Button;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Button(_ref) {
    var _classnames;

    var buttonOnly = _ref.buttonOnly,
        children = _ref.children,
        className = _ref.className,
        disabled = _ref.disabled,
        display = _ref.display,
        fullWidth = _ref.fullWidth,
        loading = _ref.loading,
        size = _ref.size,
        status = _ref.status,
        props = _objectWithoutProperties(_ref, ['buttonOnly', 'children', 'className', 'disabled', 'display', 'fullWidth', 'loading', 'size', 'status']);

    var buttonClasses = (0, _classnames3.default)('btn', className, (_classnames = {}, _defineProperty(_classnames, 'btn--' + display, display), _defineProperty(_classnames, 'btn--' + status, status), _defineProperty(_classnames, 'btn--' + size, size), _defineProperty(_classnames, 'btn--full-width', fullWidth), _defineProperty(_classnames, 'btn--loading', loading), _classnames));

    var button = _react2.default.createElement(
        'button',
        _extends({}, props, {
            className: buttonClasses,
            disabled: disabled || loading
        }),
        children
    );

    if (buttonOnly) {
        return button;
    }

    return _react2.default.createElement(
        'div',
        { className: 'form__group' },
        _react2.default.createElement(
            'div',
            { className: 'form__control' },
            button
        )
    );
}

Button.propTypes = {
    buttonOnly: _propTypes2.default.bool,
    children: _propTypes2.default.node.isRequired,
    className: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    display: _propTypes2.default.oneOf(['outline', 'link']),
    fullWidth: _propTypes2.default.bool,
    loading: _propTypes2.default.bool,
    onClick: _propTypes2.default.func,
    onMouseDown: _propTypes2.default.func,
    size: _propTypes2.default.oneOf(['small', 'large']),
    status: _propTypes2.default.oneOf(['primary', 'create', 'change', 'cancel', 'delete']),
    type: _propTypes2.default.oneOf(['submit', 'button', 'reset', 'menu'])
};

Button.defaultProps = {
    buttonOnly: false,
    className: '',
    disabled: false,
    fullWidth: false,
    loading: false,
    onClick: function onClick() {},
    onMouseDown: function onMouseDown() {},
    type: 'button'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cotidia/react-ui/lib/Button.js
// module id = 260
// module chunks = 0